module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('el-col', {
    attrs: {
      "md": 24,
      "lg": 24
    }
  }, [_c('sharers-chart', {
    attrs: {
      "sharer-data": _vm.sharers
    }
  })], 1), _vm._v(" "), (_vm.showWays) ? _c('el-col', {
    attrs: {
      "md": 24,
      "lg": _vm.showWays ? 24 : 0
    }
  }, [_c('ways-table', {
    attrs: {
      "sharer-data": _vm.sharers
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64bf90a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/sharers/SharerReport.vue
// module id = 1527
// module chunks = 0